import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { LoaderComponent } from "./libs/components/loader/loader.component";

@Component({
  selector: "sb-root",
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: "./app.component.html",
  standalone: true
})
export class App {}
